var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhitetick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7.202,
    height: 5.112,
    viewBox: "0 0 7.202 5.112",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fbfbfb;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M.582,2.446A.339.339,0,0,0,.1,2.925L2.19,5.012a.338.338,0,0,0,.485-.006L7.1.582A.339.339,0,0,0,6.621.1L2.43,4.294.582,2.446Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhitetick);
export default __webpack_public_path__ + "static/media/whitetick.ac5e42592cee7959b4e3da9537bc29e2.svg";
export { ForwardRef as ReactComponent };